import { aFetch } from '../../../core/aFetch';
import {
	IFormSaveData,
	IFormSaveDataResponse,
} from '../../../models/FormSaveData';
import { IOwuEmail, IOwuEmailResponse } from '../../../models/OwuEmail';

const endPoints = {
	sendOwuMail: '/api/owu/send',
	saveFull: '/api/insurance/save',
};

export const sendOwuMail = async (mailData: IOwuEmail) => {
	return aFetch<IOwuEmailResponse, IOwuEmail>('POST', endPoints.sendOwuMail, {
		_body: mailData,
	});
};

export const saveFull = async (saveData: IFormSaveData) => {
	return aFetch<IFormSaveDataResponse, IFormSaveData>(
		'POST',
		endPoints.saveFull,
		{
			_body: saveData,
			errorDataKey: 'errors',
		}
	);
};
